import React from "react";
import styled from "styled-components";
import { AspectRatio } from "../../../components/AspectRatio";
import { Media } from "../../../components/Media";
import { getMediaAspectRatio } from "../../../functional/getMediaAspectRatio";
const renderMediaItem = (media, youtubeLightbox) => {
    return media.type === "video" ? (React.createElement(AspectRatio, { ratio: getMediaAspectRatio(media, 16 / 9) },
        React.createElement(Media, { "data-testid": "featured-media", media: media, draggable: false, youtubeLightbox: youtubeLightbox, autoPlay: true }))) : (React.createElement(Media, { "data-testid": "featured-media", media: media, draggable: false }));
};
const MediaItem = ({ media, youtubeLightbox }) => {
    return media ? renderMediaItem(media, youtubeLightbox) : null;
};
export const MediaPromoItem = styled(MediaItem) ``;
//# sourceMappingURL=MediaItem.js.map